import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fallback_on_payment~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fallback_on_payment/web_fallback_on_payment__female'
					),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_fallback_on_payment~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fallback_on_payment/web_fallback_on_payment__female_walking'
					),
			},
		},
		'activity-female-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_fallback_on_payment~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fallback_on_payment/web_fallback_on_payment__female_yoga'
					),
			},
		},
	},
]

export default config
